import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  Table
} from "reactstrap";
import { useSelector } from 'react-redux'
import CreateEvent from "./../../components/EventCreateForm";
import EventTimeModal from "../../components/EventTimeModal";
import EventsTicketModal from "../../components/EventCreateForm/stepTwo.jsx";
import PublishEvent from "../../components/EventCreateForm/PublishEvent.jsx";
import moment from "moment";
import { deleteTimeSlots, getEventById } from "../../utils/middleware/events.js";
import { getTags } from '../../utils/middleware/marketings';
import eventImg from "../../../../assets/images/event.png";

const EventCreate = () => {

  const [selectedPage, setSelectedPage] = useState("Build event page");
  const [showPage, setShowPage] = useState("");
  const [eventData, setEventData] = useState({});
  const [enabledPages, setEnabledPages] = useState(["Build event page",]);

  const changePage = (newMessage) => {
    setSelectedPage(newMessage);
    setShowPage(newMessage);
    getTags();
  };

  useEffect(() => {
    const url = window.location.href;

    if (url.includes("/edit/")) {
      const parts = url.split("/");
      const id = parts[parts.length - 1];
      setEnabledPages((prevPages) => [...prevPages, "Add tickets", "Publish"]);
      getEventById(id, setEventData); // Fetch the event data using the ID      
    } else {
      console.log("The path does not contain 'edit'.");
    }
  }, []);

  useEffect(() => {
    if (eventData?.eventType === "recurring") {
      setEnabledPages((prevPages) => [...prevPages, "Manage dates and times"]);
    }
  }, [eventData]);

  const pages = {
    "Build event page": <CreateEvent event={eventData} setEventData={setEventData} changePage={changePage} setEnabledPages = {setEnabledPages} />,
    "Manage dates and times": <ManageDatesAndTimes eventData={eventData} changePage={changePage} setEnabledPages = {setEnabledPages} />,
    "Add tickets": <AddTickets eventData={eventData} changePage={changePage} setEnabledPages = {setEnabledPages} />,
    "Publish": <PublishPage eventData={eventData} changePage={changePage}/>,
  };

  return (
    <Container fluid className="event-schedule">
      <Row style={{ height: "80vh" }}>
        {/* Sidebar */}
        <Col md={3} className="sidebar event-sidebar-list p-3 d-none flex-column sticky-top d-md-flex h-100 bg-white rounded">
          <h3 className="text-left mb-3">Create Event</h3>
          <ListGroup>
            {Object.keys(pages).map((page) => {
              const isEnabled = enabledPages.includes(page);
              const shouldShow =
                eventData.eventType === "recurring" ||
                showPage === "Manage dates and times" ||
                page !== "Manage dates and times";

              return (
                shouldShow && (
                  <ListGroupItem
                    key={page}
                    active={selectedPage === page}
                    disabled={!isEnabled}
                    style={{
                      backgroundColor: selectedPage === page ? "#ed3c5d" : "",
                      cursor: isEnabled ? "pointer" : "not-allowed",
                      opacity: isEnabled ? 1 : 0.5
                    }}
                    onClick={() => isEnabled && setSelectedPage(page)}
                    action
                  >
                    {page}
                  </ListGroupItem>
                )
              );
            })}
          </ListGroup>
        </Col>

        {/* Main Content */}
        <Col md={9} className="event-main-content overflow-auto h-100 rounded">
          {pages[selectedPage]}
        </Col>
      </Row>
    </Container>
  );
};

const ManageDatesAndTimes = ({ eventData, changePage, setEnabledPages }) => {
  const [showAddEvenModal, setShowAddEvenModal] = useState(false)

  const handleCloseDeleteModal = () => {
    setShowAddEvenModal(false)
  }
  const { events, eventSlots } = useSelector(state => state.restaurantAdminEvents);
  const groupedSlots = eventSlots.reduce((acc, slot) => {
    if (!acc[slot.slotDate]) {
      acc[slot.slotDate] = [];
    }
    acc[slot.slotDate].push(slot);
    return acc;
  }, {});

  console.log("Grouped Slots", groupedSlots);

  const [visibleDate, setVisibleDate] = useState(null);

  // Toggle function
  const toggleTable = (date) => {
    setVisibleDate(visibleDate === date ? null : date);
  };

  const handleSlotDelete = (id) => {
    deleteTimeSlots(id);
  }

  const onNextAddTicket = () => {
    changePage("Add tickets");
    setEnabledPages((prevPages) => [...prevPages, "Add tickets"])
    
  }

  const onBackAddTicket = () => {
    changePage("Build event page");
  }

  return (
    <div className="bg-white p-4 rounded shadow-sm">
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 rounded" style={{background: "#f6f6f9"}}>
        <img src={eventImg} alt="Event" style={{width: "350px"}}/>
        <h2 className="mb-3">Manage Dates and Times</h2>
        <p>Start by adding the dates and time slots for your recurring event.</p>
        <Button color="primary" className="mt-3" onClick={() => setShowAddEvenModal(true)}>+ Add a date</Button>
      </div>
      <div className="timeslots mt-3 overflow-auto" style={{ maxHeight: "550px", overflowY: "auto" }}>
        <div className="slot-container">
          {Object.keys(groupedSlots).map((date, index) => (
            <div key={index} className="slot-group" style={{ border: "1px solid #ed3c5d", padding: "5px", borderRadius: "8px", marginTop: "10px" }}>
              {/* Date Header - Clickable */}
              <div className="slot-header" onClick={() => toggleTable(date)} style={{ cursor: "pointer" }}>
                <h5 className="text-danger mb-0">
                  {moment(date).format("ddd")} {moment(date).format("DD")}
                </h5>
                <span className="text-dark">{moment(date).format("MMMM")}</span>
                <span className="ml-2 text-muted">{groupedSlots[date].length} time slots</span>
                {visibleDate === date && (
                  <div className="slot-actions">
                    <Button color="danger" size="sm" className="ml-2" onClick={() => handleSlotDelete(groupedSlots[date].map(slot => slot.eventId))}>Delete date</Button>
                  </div>
                )}
                {visibleDate !== date && (
                  <div className="slot-actions">
                    {groupedSlots[date].map((slot) => {
                      const startTime = moment(slot.startTime, "HH:mm").format("h:mm A");
                      return (
                        <Button key={slot.id} color="danger" size="sm" className="ml-2">{startTime}</Button>
                      );

                    })}
                  </div>
                )}
              </div>

              {/* Slot Table (Toggled) */}
              {visibleDate === date && (
                <Table bordered striped className="mt-2">
                  <thead>
                    <tr>
                      <th>Time Slot</th>
                      <th>Duration</th>
                      <th>Visible Tickets</th>
                      <th>Ticket Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedSlots[date].map((slot) => {
                      const startTime = moment(slot.startTime, "HH:mm").format("h:mm A");
                      const endTime = moment(slot.endTime, "HH:mm").format("h:mm A");
                      const duration = moment(slot.endTime, "HH:mm").diff(moment(slot.startTime, "HH:mm"), "minutes");

                      return (
                        <tr key={slot.id}>
                          <td>{startTime}</td>
                          <td>{duration / 60}h</td>
                          <td>No tickets</td>
                          <td>No tickets</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}


            </div>
          ))}
        </div>
      </div>
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <Button
            color='outline-primary'
            type="button"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
          <Button color='primary' type="button" onClick={onBackAddTicket} >
            Back
          </Button>
          <Button color='primary' type="button" onClick={onNextAddTicket} >
            Next
          </Button>
        </div>
      {showAddEvenModal && <EventTimeModal open={showAddEvenModal} eventData={eventData} handleCloseModal={handleCloseDeleteModal} />}
    </div>
  );
};

const AddTickets = ({ eventData, changePage, setEnabledPages}) => (
  <div>
    <EventsTicketModal eventData={eventData} changePage={changePage} setEnabledPages={setEnabledPages}/>
  </div>
);

const PublishPage = ({ eventData, changePage }) => (
  <div>
    <PublishEvent eventData={eventData} changePage={changePage}/>
  </div>
);

export default EventCreate;